// @flow
import PrimaryPalette from '../../../colors';

const Theme = {
  default: {
    backgroundColor: PrimaryPalette.white,
    borderColor: PrimaryPalette.mediumGrey,
    color: PrimaryPalette.mediumEvergreen,
    labelColor: PrimaryPalette.lightEvergreen,
    requiredColor: PrimaryPalette.mediumPoppy,
  },
  focused: {
    borderBottomColor: PrimaryPalette.darkGreen,
    color: PrimaryPalette.darkGreen,
  },
  error: {
    borderColor: PrimaryPalette.mediumPoppy,
    color: PrimaryPalette.mediumPoppy,
  },
  disabled: {
    backgroundColor: PrimaryPalette.mediumGrey,
    labelColor: PrimaryPalette.darkerGrey,
    color: PrimaryPalette.darkerGrey,
  },
};

export default Theme;
